import { extractUrlFromIconJsonLd } from '../url';
export var extractPersonFromJsonLd = function extractPersonFromJsonLd(person) {
  if (typeof person === 'string') {
    throw Error('Link.person needs to be an object.');
  } else if (person['@type'] === 'Link') {
    if (person.name) {
      return {
        name: person.name
      };
    }
  } else {
    if (person.name) {
      return {
        name: person.name,
        src: person.icon && extractUrlFromIconJsonLd(person.icon)
      };
    }
  }
};